import { CadreDuTelephone } from '../telephone';
import { Aide, Tuto } from '../aide';
import { useDeconnexion, useEmailConnecte } from '../partage/useArbre';
import { useAuPouce, useCouche } from '../partage/surface';
import { BarreDeGauche } from './BarreDeGauche';
import './Cadre.css';

/**
 * Le cadre commun : ce qui entoure toutes les pages une fois connecté. Il choisit selon
 * l'appareil (`useAuPouce`, 720 px) : au téléphone, son cadre à lui (`CadreDuTelephone`, la date,
 * les cinq boutons du bas, ses panneaux) ; à l'ordinateur, la barre de gauche (chantier
 * `navigation`, 01), le tuto et l'ampoule de l'Aide.
 *
 * Sorti de `telephone/` au chantier `navigation` (04, décision d'Igor du 2026-10-19) : le
 * rangement du 2026-10-10 l'y avait mis parce que l'essentiel en était le téléphone ; avec la
 * barre de gauche, l'ordinateur y pèse autant. Les mêmes vues dans les deux cas : aucune fonction
 * n'est réservée à l'une des deux surfaces (SPEC §1).
 *
 * Le téléphone couché (`useCouche`, chantier telephone-couche-suite, 01) : une seule règle, toute
 * page prend le cadre du téléphone en rail à gauche (`couche`) ; chaque écran choisit ensuite sa
 * vue couchée. Elle remplace les règles par page d'avant (le projet, le Profil). Une fenêtre
 * d'ordinateur large et basse n'est jamais un téléphone couché (`estCouche`).
 */
export function Cadre({ children }: { children: React.ReactNode }) {
  const auPouce = useAuPouce();
  const couche = useCouche();
  const deconnexion = useDeconnexion();
  const email = useEmailConnecte();

  if (couche) {
    return (
      <div className="cadre cadre--couche">
        <CadreDuTelephone couche>{children}</CadreDuTelephone>
      </div>
    );
  }

  if (auPouce) {
    return (
      <div className="cadre cadre--au-pouce">
        <CadreDuTelephone>{children}</CadreDuTelephone>
      </div>
    );
  }

  return (
    <div className="cadre cadre--ordinateur">
      <BarreDeGauche email={email} onSortir={() => deconnexion.mutate()} />

      {/*
        Le tuto (tickets 31 et 33) et l'ampoule de l'Aide (ticket 11 de retours-testeurs) : sur
        ordinateur seulement. Au téléphone, ni présentation ni ampoule (décision d'Igor,
        ticket 01 de telephone) : ce sont les deux seuls composants qui appellent `useTuto()`,
        et ne pas les monter suffit à ce que la présentation ne se lance pas.
      */}
      <Tuto />
      <Aide />

      <main className="cadre-corps">{children}</main>
    </div>
  );
}
